import Button from "app/components/shared/Button";
import SectionLoader from "app/components/shared/SectionLoader";

import { useGuides } from "./use-guide";
import { GuideItem } from "./GuideItem";
import { GuideList } from "./GuideList";

export function Guide() {
  const { onReload, loading, error, selectedItem } = useGuides();

  if (loading) {
    return <SectionLoader />;
  }

  if (error) {
    return (
      <>
        <p className="mt-0">Unable to load content.</p>
        <Button theme="small" onClick={onReload}>
          Retry
        </Button>
      </>
    );
  }

  return (
    <div className="relative flex flex-col gap-3">
      {selectedItem ? <GuideItem /> : <GuideList />}
    </div>
  );
}
